import styled, { keyframes } from 'styled-components';

const tick = keyframes`
  0%   { transform: rotate(-12deg); }
  50%  { transform: rotate(12deg); }
  100% { transform: rotate(-12deg); }
`;

export const PageContainer = styled.main`
  min-height: calc(100vh - 80px);
  background: #f7f6f1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem 1.5rem;
`;

export const Content = styled.div`
  max-width: 540px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
`;

export const Dial = styled.div`
  position: relative;
  width: 180px;
  height: 180px;
  border-radius: 50%;
  border: 2px solid #b8964a;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle at 30% 30%, #fff 0%, #efece4 70%);
  box-shadow:
    inset 0 0 0 8px #fff,
    inset 0 0 0 9px rgba(184, 150, 74, 0.35),
    0 18px 40px rgba(0, 0, 0, 0.18);
  margin-bottom: 0.5rem;

  @media (max-width: 600px) {
    width: 140px;
    height: 140px;
  }

  /* hour markers */
  &::before,
  &::after {
    content: '';
    position: absolute;
    background: #1a1a1a;
  }
  &::before {
    width: 2px;
    height: 14px;
    top: 14px;
    left: 50%;
    transform: translateX(-50%);
  }
  &::after {
    width: 14px;
    height: 2px;
    top: 50%;
    right: 14px;
    transform: translateY(-50%);
  }
`;

export const DialNumber = styled.div`
  font-family: 'Abel', sans-serif;
  font-size: 3rem;
  font-weight: 400;
  color: #1a1a1a;
  letter-spacing: 0.1em;
  z-index: 1;

  @media (max-width: 600px) {
    font-size: 2.3rem;
  }
`;

export const SecondHand = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 2px;
  height: 70px;
  background: #b8964a;
  transform-origin: bottom center;
  transform: translate(-50%, -100%);
  border-radius: 2px;
  animation: ${tick} 2.5s ease-in-out infinite;
  z-index: 2;

  &::after {
    content: '';
    position: absolute;
    bottom: -7px;
    left: 50%;
    width: 12px;
    height: 12px;
    background: #b8964a;
    border-radius: 50%;
    transform: translateX(-50%);
  }

  @media (max-width: 600px) {
    height: 54px;
  }
`;

export const Title = styled.h1`
  font-family: 'Abel', sans-serif;
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #1a1a1a;
  margin: 0;
`;

export const Lead = styled.p`
  font-family: 'Abel', sans-serif;
  font-size: 1rem;
  line-height: 1.55;
  color: #444;
  margin: 0;
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.7rem;
  justify-content: center;
  margin-top: 0.5rem;
`;

export const PrimaryBtn = styled.button`
  background: #b8964a;
  color: #fff;
  border: none;
  padding: 0.85rem 1.5rem;
  border-radius: 6px;
  font-family: 'Abel', sans-serif;
  font-size: 0.95rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.15s ease;

  &:hover { background: #a07f3a; transform: translateY(-1px); }
`;

export const SecondaryBtn = styled.button`
  background: transparent;
  color: #1a1a1a;
  border: 1px solid #1a1a1a;
  padding: 0.85rem 1.5rem;
  border-radius: 6px;
  font-family: 'Abel', sans-serif;
  font-size: 0.95rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;

  &:hover { background: #1a1a1a; color: #fff; }
`;

export const QuickLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem 1rem;
  justify-content: center;
  margin-top: 1rem;
  font-size: 0.85rem;
  color: #666;

  a {
    color: #657455;
    cursor: pointer;
    text-decoration: underline;
  }
`;
